@import "../../../globals/scss/button";

.toggle {
  // styles being reset by .button-reset in tsx
  color: $token-text-color-interaction-default;
  border-radius: $border-radius;

  // disable focus-visible till SDX-1939
  @include focus-visible {
    outline: 0;
  }

  &:hover {
    color: $token-text-color-interaction-hover;
    background-color: $color-blue-tint-3;
  }
}

.toggle.sdx--dark-theme {
  color: $color-int-blue2-dark-theme;

  &:hover {
    color: $color-int-blue2-dark-theme--active;
    background-color: rgba($color-blue-tint-3-dark-theme, 0.15);
  }
}

.toggle {
  &.sdx--light-theme,
  &.sdx--dark-theme {
    &.dark {
      color: $color-white;

      @include active-hover {
        background-color: rgba($color-white, 0.15);
      }
    }
  }
}
